import React from "react";

const SunIcon = () => (
  <svg width="24" height="24" fill="none">
    <path
      d="M12 3.8V1.5M12 17.3a5.2 5.2 0 1 0 0-10.5 5.2 5.2 0 0 0 0 10.4ZM6 6 4.5 4.5M6 18l-1.5 1.5M18 6l1.5-1.5M18 18l1.5 1.5M3.8 12H1.5M12 20.3v2.2M20.3 12h2.2"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);

export default SunIcon;
